// apps/accounts/src/components/StaffSidebar.jsx
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  LayoutDashboard, ClipboardCheck, Package, RefreshCw, 
  LogOut, User, Sparkles
} from 'lucide-react';
import { cn } from '../lib/utils';

export const StaffSidebar = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const navItems = [
    { path: '/staff/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/staff/attendance', label: 'Attendance', icon: ClipboardCheck },
    { path: '/staff/materials', label: 'Materials Update', icon: Package },
    { path: '/staff/stock', label: 'Stock Update', icon: RefreshCw },
  ];

  const renderNavLink = (item) => {
    const isActive = location.pathname === item.path;
    return (
      <NavLink
        key={item.path}
        to={item.path}
        className={cn(
          'flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200',
          isActive
            ? 'bg-emerald-500/20 text-emerald-400 border-r-2 border-emerald-400'
            : 'text-slate-300 hover:bg-slate-800/50 hover:text-white'
        )}
      >
        <item.icon className="w-5 h-5 flex-shrink-0" />
        <span className="truncate">{item.label}</span>
      </NavLink>
    );
  };

  return (
    <aside className="w-64 bg-slate-900 text-slate-300 h-full overflow-y-auto flex-shrink-0 border-r border-slate-800">
      <div className="p-4 border-b border-slate-800/50">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-emerald-500/20 flex items-center justify-center">
            <User className="w-4 h-4 text-emerald-400" />
          </div>
          <div>
            <p className="text-sm font-semibold text-white">Staff Panel</p>
            <p className="text-xs text-slate-400">{user?.name || 'Staff'}</p>
          </div>
        </div>
        <div className="flex items-center gap-2 mt-2 pt-2 border-t border-slate-800/50">
          <span className="text-xs text-emerald-400">?? Site Access</span>
        </div>
      </div>

      <nav className="p-3 space-y-1">
        {navItems.map(renderNavLink)}
        
        <div className="mt-4 pt-4 border-t border-slate-700/50">
          <div className="flex items-center gap-2 px-3 py-2 text-xs text-slate-400">
            <Sparkles className="w-4 h-4" />
            <span>{user?.name || user?.email}</span>
          </div>
          <button
            onClick={logout}
            className="flex items-center gap-3 px-3 py-2.5 w-full rounded-lg text-sm font-medium text-red-400 hover:bg-red-500/10 hover:text-red-300 transition-all duration-200"
          >
            <LogOut className="w-5 h-5 flex-shrink-0" />
            <span>Logout</span>
          </button>
        </div>
      </nav>
    </aside>
  );
};

export default StaffSidebar;